import alt from './alt'
import Actions from './action'
import _ from 'lodash'

var bindListenersObject = {};
for (var i in Actions)
    if (typeof Actions[i] === "function")
        bindListenersObject[i] = Actions[i];

export default alt.createStore({
    displayName: 'store',
    progressModel: undefined,
    publicMethods: {},
    bindListeners: bindListenersObject,
    state: {
        route: "home",
        sidebarExpand: false,
        test: "test",
        profile: {
            basic: {
                email: "susmita@gmail.com",
                fName: "Susmita",
                mName: "",
                sName: "Chaudhury",
                headline: "Analytics Innovation",
                dob: new Date(1967, 11, 9), // year month day .. month starts from 0, so dec is 11
                city: "Bangalore", 
                country: "India",
                coverMsg: "I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful."
            },
            introVid: "",
            openForJob: true,
            empHistory: [{
                experience: "Ipsos - MMA",
                title: "Executive Vice President",
                empType: "fulltime",
                startDate: new Date(2011, 1, 9),
                endDate: undefined,
                city: "Bangalore", 
                country: "India",
                rolesummary: "Management and Development",
                description: "Build the Analytics Centre of Excellence, head the operational decision making, manage delivery and quality, capability building, talent management. Build the Analytics Centre of Excellence, head the operational decision making, manage delivery and quality, capability building, talent management.Build the Analytics Centre of Excellence, head the operational decision making, manage delivery, Build the Analytics Centre of Excellence, head the operational decision making, manage delivery and quality, capability building, talent management. Build the Analytics Centre of Excellence, head the operational decision making, manage delivery and quality, capability building, talent management.Build the Analytics Centre of Excellence, head the operational decision making, manage delivery, Build the Analytics Centre of Excellence, head the operational decision making, manage delivery and quality, capability building, talent management. Build the Analytics Centre of Excellence, head the operational decision making, manage delivery and quality, capability building, talent management.Build the Analytics Centre of Excellence, head the operational decision making, manage delivery",
                active: true
            },{
                experience: "Ipsos - MMA",
                title: "Group Manager",
                empType: "fulltime",
                startDate: new Date(2008, 1, 9),
                endDate: new Date(2011, 1, 9),
                city: "Bangalore", 
                country: "India",
                rolesummary: "Management and Development",
                description: "Pricing, Trade Promotion, Marketing Mix Analytics for CPG and Retail clients, Analytic Product Development, Loyalty Analytics",
                active: false
            },{
                experience: "SC Analytics",
                title: "Assisstant Manager",
                empType: "fulltime",
                startDate: new Date(2015, 6, 9),
                endDate: new Date(2018, 1, 9),
                city: "Bangalore", 
                country: "India",
                rolesummary: "Management and Development",
                description: "Pricing, Trade Promotion, Marketing Mix Analytics for CPG and Retail clients, Analytic Product Development, Loyalty Analytics",
                active: false
            },{
                experience: "Symphony Marketing Solutions",
                title: "EVP",
                empType: "fulltime",
                startDate: new Date(2011, 10, 9),
                endDate: new Date(2015, 6, 9),
                city: "Bangalore", 
                country: "India",
                rolesummary: "Management and Development",
                description: "Pricing, Trade Promotion, Marketing Mix Analytics for CPG and Retail clients, Analytic Product Development, Loyalty Analytics",
                active: false
            }],
            remuneration : {
                band: 5, 
                currency: 0
            },
            qualifications : [{
                degree: "Masters",
                field: "Economics",
                institute: "Jawaharlal Nehru University",
                city: "Delhi",
                country: "India",
                instituteLink: "",
                startDate: new Date(2009, 10, 9),
                endDate: new Date(2011, 10, 9),
                description: "Specialization in Econometrics",
                active: false,
                scoreType:  'CGPA',
                score:  7.3,
                total: 8,
                divisionType: 1
            },{
                degree: "Bachelors",
                field: "Economics",
                institute: "St. Xavier's College",
                city: "Delhi",
                country: "India",
                instituteLink: "",
                startDate: new Date(2005, 10, 9),
                endDate: new Date(2009, 10, 9),
                description: "Optionals in Political Science",
                active: false,
                scoreType:  'grade',
                score:  'A+',
                total: undefined,
                divisionType: 3
            },{
                degree: "ISC",
                field: "Science",
                institute: "Calcutta Girls' High School",
                city: "Kolkata",
                country: "India",
                instituteLink: "",
                startDate: new Date(2003, 10, 9),
                endDate: new Date(2005, 10, 9),
                description: "Additionals in Computer Science",
                active: false,
                scoreType:  'percentage',
                score:  91,
                total: undefined,
                divisionType: 0
            }],
            accomplishments: {
                'awards' : [{
                    title: 'Star of the Month',
                    association: 'IRI - Symphony Marketing Solutions',
                    city: 'Kolkata',
                    country: 'India',
                    date: new Date(2005, 10, 9),
                    description: 'desp....',
                },{
                    title: 'Calcutta University 11th Rank',
                    association: 'NIIT',
                    city: 'Kolkata',
                    country: 'India',
                    date: new Date(2005, 10, 9),
                    description: 'desp...',
                },{
                    title: 'CBSE Topper',
                    association: 'Some School',
                    city: 'Kolkata',
                    country: 'India',
                    date: new Date(2005, 10, 9),
                    description: 'desp...',
                    invisible: true
                },
                ],
                "projects" : [{
                    title: 'AI',
                    association: 'SRM',
                    date: new Date(2005, 10, 9),
                    city: 'Chennai',
                    country: 'India',
                    description: 'Robotics',
                    extrafield: 'www.test.com'
                },{
                    title: 'Quiz App',
                    association: 'SRM',
                    date: new Date(2005, 10, 9),
                    city: 'Chennai',
                    country: 'India',
                    description: 'Robotics',
                    extrafield: 'www.test.com'
                }],
                'courses' : [{
                    title: 'FORTRAN Advanced Course',
                    association: 'association...',
                    date: new Date(2005, 10, 9),
                    city: 'kolkata',
                    country: 'India',
                    description: 'NIIT, Calcutta, India',
                }],
                'events' : [{
                    title: 'College Fest - Milan',
                    association: 'test',
                    date: new Date(2005, 10, 9),
                    city: 'kolkata',
                    country: 'India',
                    description: 'role ... ',
                }],
                "volunteer" : [{
                    title: 'College Fest - Milan',
                    association: 'test',
                    // date: new Date(2005, 10, 9),
                    city: 'kolkata',
                    country: 'India',
                    description: 'role ... ',
                }],
                "publications" : [{
                    title: 'College Fest - Milan',
                    association: 'test',
                    date: new Date(2005, 10, 9),
                    city: 'kolkata',
                    country: 'India',
                    description: 'role ... ',
                    extrafield: 'www.test.com'
                }],
                "conferences" : [{
                    title: 'College Fest - Milan',
                    association: 'test',
                    date: new Date(2005, 10, 9),
                    city: 'kolkata',
                    country: 'India',
                    description: 'role ... ',
                }],
                "patents" : [{
                    title: 'College Fest - Milan',
                    association: 'test',
                    date: new Date(2005, 10, 9),
                    city: 'kolkata',
                    country: 'India',
                    description: 'role ... ',
                    extrafield: 'www.test.com',
                    extrafield2: '6253927483',
                    extrafield3: "pending" // issued
                }],
            },
            references: [{
                name: 'Manjula Sharada',
                association: 'GE Capital International Services',
                relation: 'Manager',
                email: 'manjula.sharada@gmail.com',
                phone: '+91 9922456781'
            },{
                name: 'Anjan Mukherjee',
                association: 'Jawaharlal Nehru University',
                relation: 'Professor',
                email: 'anjan.mukherjee@jnu.com',
                phone: '+91 9922456781'
            }],
            extracurriculars: [{
                interest: 'Music',
                description: "test",
                date: new Date(2005, 10, 9),
                association: 'GE Capital International Services',
                relation: 'Manager',
                city: 'Kolkata',
                country: 'India',
            },{
                interest: 'Music',
                description: "test",
                date: new Date(2005, 10, 9),
                association: 'GE Capital International Services',
                relation: 'Manager',
                city: 'Kolkata',
                country: 'India',
            },{
                interest: 'Swimming',
                description: "",
                date: undefined,
                association: '',
                relation: '',
                city: '',
                country: '',
            },{
                interest: 'Watching Movies',
                description: "test",
                date: undefined,
                association: '',
                relation: '',
                city: '',
                country: '',
            },{
                interest: 'Reading',
                description: "test",
                date: undefined,
                association: '',
                relation: '',
                city: '',
                country: '',
            }],
            personalInfo: {
                gender: 'Male',
                status: 'Married',
                languages: ['English', "Bengali"],
                visa: 'B1/B2',
                stateReallocate: true,
                countryReallocate: true,
                workFromHome: true,
            },
            contactInfo: {
                addressField1: "BC 41/7",
                addressField2: "Saltlake, Sector 1",
                addressField3: "",
                city: "kolkata",
                state: "West Bengal",
                country: "India",
                pin: "700064",
                email: "rudraroy1507@gmail.com",
                phone: "9830066694",
                phone2: "8981621293"
            }
        },
    },
    storeSetState(o) {
        this.setState(o)
    },
    setBasicFields(basic) {
        // Call Service 
        var { profile } = this.state
        profile.basic = basic
        this.setState(profile)
    },
    setEmpHistory(empHistory) {
        // Call Service 
        var { profile } = this.state
        profile.empHistory = empHistory
        this.setState(profile)
    },
    setRemuneration(remuneration){
        // Call Service 
        var { profile } = this.state
        profile.remuneration = remuneration
        this.setState(profile)
    },
    setQualifications(qualifications) {
        // Call Service 
        var { profile } = this.state
        profile.qualifications = qualifications
        this.setState(profile)
    },
    setAccomplishments(accomplishments) {
        // Call Service 
        var { profile } = this.state
        profile.accomplishments = accomplishments
        this.setState(profile)
    },
    setReferences(references) {
        // Call Service 
        var { profile } = this.state
        profile.references = references
        this.setState(profile)
    },
    setExtracurriculars(extracurriculars) {
        // Call Service 
        var { profile } = this.state
        profile.extracurriculars = extracurriculars
        this.setState(profile)
    },
    setPersonalInfo(personalInfo) {
        // Call Service 
        var { profile } = this.state
        profile.personalInfo = personalInfo
        this.setState(profile)
    },
    setContactInfo(contactInfo) {
        // Call Service 
        var { profile } = this.state
        profile.contactInfo = contactInfo
        this.setState(profile)
    },
})